import React from 'react'
import PropTypes from 'prop-types'

import Chart from 'chart.js'

var chart = null

export default function AtlasChart ({ chartId, chartType, data, options, height }) {
  // console.log('chart data is: ', data)
  React.useEffect(() => {
    if (data.labels === undefined || data.dataSet === undefined) {

    } else {
      var ctx = document.getElementById(chartId).getContext('2d')

      chart = new Chart(ctx, {
        type: chartType,
        data: {
          labels: data.labels,
          datasets: data.dataSet
        },
        options: options
      })
    }
  }, [])

  React.useEffect(() => {
    chart.update()
  }, [data])

  return <canvas id={chartId} height={height}></canvas>
}

AtlasChart.propTypes = {
  chartId: PropTypes.string,
  chartType: PropTypes.string,
  data: PropTypes.object,
  options: PropTypes.object,
  height: PropTypes.string
}
